import {Injectable} from '@angular/core';
import {FascicoloFull} from "../../../common/models/fascicolo/fascicolo-full";
import {RowSezione} from "../../../common/models/fascicolo/row-sezione";
import {VoceSezione} from "../../../common/models/fascicolo/voce-sezione";
import {
  FormAutoritaIndipendentiRegolatorieComponent
} from "../form-autorita-indipendenti-regolatorie/form-autorita-indipendenti-regolatorie.component";
import {
  FormAutoritaIndipendentiRegolatorieViewComponent
} from "../form-autorita-indipendenti-regolatorie/view/form-autorita-indipendenti-regolatorie-view.component";
import {
  FormRecuperoCreditiStragiudizialeComponent
} from "../form-recupero-crediti-stragiudiziale/form-recupero-crediti-stragiudiziale.component";
import {
  FormRecuperoCreditiStragiudizialeViewComponent
} from "../form-recupero-crediti-stragiudiziale/view/form-recupero-crediti-stragiudiziale-view.component";
import {
  FascicoloAutoritaIndipendentiRegolatorie
} from "../models/autorita-indipendente-regolatorie/fascicolo-autorita-indipendenti-regolatorie";
import {
  FascicoloRecuperoCreditiStragiudiziale
} from "../models/recupero-crediti-stragiudiziale/fascicolo-recuperocreditistragiudiziale";

@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor() {
  }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'autorita': {
        fascicolo = new FascicoloAutoritaIndipendentiRegolatorie();
        break;
      }
      case 'recuperocreditistragiudiziale': {
        fascicolo = new FascicoloRecuperoCreditiStragiudiziale();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;

    switch (idFormTenant) {
      case 'AutAut_PRD': {
        component = view ? FormAutoritaIndipendentiRegolatorieViewComponent : FormAutoritaIndipendentiRegolatorieComponent; // AUTORITAINDIPENDENTI E REGOLATORIE
        break;
      }
      case 'AutRec_PRD': {
        component = view ? FormRecuperoCreditiStragiudizialeViewComponent : FormRecuperoCreditiStragiudizialeComponent; // RECUPERO CREDITI STRAGIUDIZIALE
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic: string, assegnatario?: string): RowSezione[] {
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    let esiti = this.getEsitiFromCopertina(fascicolo);
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    switch (genericFascicolo) {
      case 'autorita': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            // new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'recuperocreditistragiudiziale': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Natura', fascicolo.copertina.campi.natura),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti),
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'text', 'Legale di controparte', fascicolo.copertina.campi.legaliControparti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Fondo rischi SI/NO', true === fascicolo.copertina.campi.fondoRischi ? 'Si' : 'No'),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(6, 'date', 'Data apertura fascicolo', fascicolo.copertina.campi.dataInizioFascicolo),
            new VoceSezione(6, 'date', 'Data notifica', fascicolo.dataNotifica)
          ]),
          new RowSezione('Diffida', [
            new VoceSezione(4, 'text', 'Ultima lettera diffida (numero invii)',
              (fascicolo.copertina.campi.tipoUltimaLetteraDiffida ? (fascicolo.copertina.campi.tipoUltimaLetteraDiffida +
                ' (' + (fascicolo.copertina.campi.numeroInviiDiffida ? fascicolo.copertina.campi.numeroInviiDiffida : '0') + ')') : '')),
            new VoceSezione(4, 'date', 'Data ultima diffida', fascicolo.copertina.campi.dataUltimaLetteraDiffida),
            new VoceSezione(4, 'text', 'Esito ultimo invio', fascicolo.copertina.campi.esitoUltimoInvioDiffida)
          ]),
          esiti.length > 0 ? new RowSezione("Esiti",esiti) : new RowSezione(null, null),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]),
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }

  getEsitiFromCopertina(fascicolo: FascicoloFull): any[]{
    let listaVoci = [];
    if (fascicolo.copertina.campi.esiti) {
      for (let esito of fascicolo.copertina.campi.esiti) {
        listaVoci.push(new VoceSezione(3, "text", "Esito", esito.esitoPerSocieta));
        listaVoci.push(new VoceSezione(3, "text", "Tipo", esito.tipoSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Numero/Anno", esito.numeroSentenza));
        listaVoci.push(new VoceSezione(3, "text", "Risoluzione per parte", esito.esitoRisoluzioneParte));
      }
    }
    return listaVoci;
  }

  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
